import React from "react";
import { Loader2 } from "lucide-react";
import { AttachmentChip, extractIncomplete } from "./AttachmentChip";
import { ExtractRecoverBanner } from "./ExtractRecoverBanner";

/**
 * Composer attachment chips + recover banner.
 * Replace only opens the file picker (via onBeginReplace); it never sends.
 * Cancel / failed upload must leave the incomplete chip in place (handled by parent).
 */
export function ComposerAttachments({
  attachments,
  uploading,
  setAttachments,
  onBeginReplace,
}) {
  const removeAt = (i) => setAttachments((p) => p.filter((_, j) => j !== i));
  return (
    <>
      <ExtractRecoverBanner
        attachments={attachments}
        onReplaceFirst={() => {
          const first = attachments.find(extractIncomplete);
          if (first?.id) onBeginReplace?.(first.id);
        }}
      />
      {(attachments.length > 0 || uploading) && (
        <div data-testid="composer-attachments" className="mb-2 flex flex-wrap items-center gap-1.5">
          {attachments.map((a, i) => (
            <AttachmentChip
              key={a.id}
              att={a}
              testid="attachment-chip"
              onRemove={() => removeAt(i)}
              onReplace={extractIncomplete(a) ? () => onBeginReplace?.(a.id) : undefined}
            />
          ))}
          {uploading && (
            <span className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-widest text-slate-500">
              <Loader2 className="h-3.5 w-3.5 animate-spin text-brand" /> Uploading & extracting…
            </span>
          )}
        </div>
      )}
    </>
  );
}
